import {ReactComponent as Info} from '../../images/icons/info.svg';
import {ReactComponent as Settings} from '../../images/icons/settings.svg';
import { ReactComponent as Fullscreen } from '../../images/icons/maximize.svg';
import {ReactComponent as EscFullscreen} from '../../images/icons/screen.svg';
import React, { RefObject } from "react";
import {AmplitudeEvent, logEvent} from "../utils/amplitude";

interface Props {
    showInfo: () => void;
    showConfig: () => void;
    screenRef?: RefObject<HTMLDivElement>;
}

const GameActions = ({showInfo, showConfig, screenRef}: Props) => {
    const enterFullScreen = () => { 
        screenRef?.current?.requestFullscreen();
    }
    const exitFullScreen = () => {
        document.exitFullscreen(); 
    }
    
    const showInfoClick = () => {
        logEvent(AmplitudeEvent.BTN_CLICK, {btnName: "game-play-show-info"});
        showInfo();
    };

    const showConfigClick = () => {
        logEvent(AmplitudeEvent.BTN_CLICK, {btnName: "game-play-show-config"});
        showConfig();
    };

    const switchToFullScreenClick = () => {
        logEvent(AmplitudeEvent.BTN_CLICK, { btnName: "game-play-fullscreen" });
        enterFullScreen();
    };

    const switchToNormalScreenClick = () => {
        logEvent(AmplitudeEvent.BTN_CLICK, { btnName: "game-play-normalscreen" });
        exitFullScreen();
    };
    
    return (
        <div className="flex flex-row gap-[20px] justify-center items-center">
            <Info className="no-fullscreen block cursor-pointer" onClick={showInfoClick}/>
            <Settings className="no-fullscreen block cursor-pointer" onClick={showConfigClick}/>
            <EscFullscreen className="fullscreen hidden cursor-pointer" onClick={switchToNormalScreenClick} />
            <Fullscreen className="no-fullscreen block cursor-pointer" onClick={switchToFullScreenClick} />
        </div>
    )
};

export default GameActions;
